/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Time_Slots_Display_Add_AfterInputs */

const en_time_slots_display_add_after = /** @type {(inputs: Time_Slots_Display_Add_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add another slot after`)
};

const de_time_slots_display_add_after = /** @type {(inputs: Time_Slots_Display_Add_AfterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`weiteren Slot danach hinzufügen`)
};

/**
* | output |
* | --- |
* | "Add another slot after" |
*
* @param {Time_Slots_Display_Add_AfterInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const time_slots_display_add_after = /** @type {((inputs?: Time_Slots_Display_Add_AfterInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Time_Slots_Display_Add_AfterInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_time_slots_display_add_after(inputs)
	return en_time_slots_display_add_after(inputs)
});